import React, { useContext } from 'react';
import SearchField from './components/SearchField';
import FreeDevicesSwitch from './components/FreeDevicesSwitch';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import {
	AssignDevicesContext,
	IAssignDevicesContext,
} from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/components/Forms/components/DevicesForm/devicesFormState/devicesFormContext';
import style from './AssignDevicesControlPanel.module.scss';

const AssignDevicesControlPanel: React.FC = () => {
	const {
		changeSearchString,
		toggleSetShowFreeDevices,
		setSortBy,
		setCountOfItems,
		searchString,
		showFreeDevices,
		sortBy,
		countOfItems,
	} = useContext<IAssignDevicesContext>(AssignDevicesContext);

	return (
		<>
			<div className={style.firstRowWithControls}>
				<SearchField searchString={searchString} changeSearchString={changeSearchString} />
			</div>
			<div className={style.secondRowWithControls}>
				<FreeDevicesSwitch
					showFreeDevices={showFreeDevices}
					toggleSetShowFreeDevices={toggleSetShowFreeDevices}
				/>
				<div className={style.verticalAlignBlock}>
					<SortBy sortBy={sortBy} setSortBy={setSortBy} />
					<CountOfItem countOfItems={countOfItems} setCountOfItems={setCountOfItems} />
				</div>
			</div>
		</>
	);
};

export default React.memo(AssignDevicesControlPanel);
